import { Graphics } from 'pixi.js';

// Wave-clear RGB-split screen wipe — 3 chromatic-offset bars (cyan / white / magenta)
// sweeping across the screen for `dur` seconds. Trigger via `.trigger(dur)`,
// tick every frame via `.tick(dt, W, H)`.
export class WipeOverlay {
  view: Graphics;
  private t = 0;
  private dur = 0.55;

  constructor() {
    this.view = new Graphics();
    this.view.blendMode = 'add';
    this.view.visible = false;
  }

  trigger(dur = 0.55): void {
    this.t = dur;
    this.dur = dur;
  }

  tick(dt: number, W: number, H: number): void {
    if (this.t > 0) {
      this.t = Math.max(0, this.t - dt);
      this.view.visible = true;
      const t = 1 - this.t / this.dur;
      const eased = 1 - Math.pow(1 - t, 2);
      const sweepW = W * 0.6;
      const xCenter = -sweepW + (W + sweepW * 2) * eased;
      this.view.clear();
      const alpha = 0.55 * (1 - Math.abs(t - 0.5) * 2);
      this.view.rect(xCenter - sweepW / 2 - 18, 0, sweepW, H);
      this.view.fill({ color: 0x00ffff, alpha: alpha * 0.5 });
      this.view.rect(xCenter - sweepW / 2,      0, sweepW, H);
      this.view.fill({ color: 0xffffff, alpha });
      this.view.rect(xCenter - sweepW / 2 + 18, 0, sweepW, H);
      this.view.fill({ color: 0xff44ff, alpha: alpha * 0.5 });
    } else if (this.view.visible) {
      this.view.visible = false;
      this.view.clear();
    }
  }
}
